import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ChatMessage } from '@/types/chat';
import MessageContent from './MessageContent';
import { formatDistanceToNow } from 'date-fns';

interface ThreadRepliesProps {
  replies: ChatMessage[];
  onCollapse: () => void;
  currentUsername?: string;
}

const ThreadReplies = ({ 
  replies, 
  onCollapse, 
  currentUsername 
}: ThreadRepliesProps) => {
  const getDisplayName = (message: ChatMessage) => {
    return message.user_profile?.username || 
           message.user_profile?.first_name || 
           'Unknown User';
  };

  const formatTime = (timestamp: string) => {
    try {
      return formatDistanceToNow(new Date(timestamp), { addSuffix: true });
    } catch {
      return timestamp;
    }
  };

  return (
    <div className="ml-12 mt-1 mb-2 border-l-2 border-primary/30 pl-4 space-y-2">
      {/* Collapse button */}
      <Button
        variant="ghost"
        size="sm"
        onClick={onCollapse}
        className="h-7 text-xs text-muted-foreground hover:text-foreground"
      >
        <ChevronDown className="h-3 w-3 mr-1" />
        Replies
      </Button>

      {/* Reply messages */}
      {replies.map((reply) => (
        <div
          key={reply.message_id}
          className="bg-muted/30 rounded-lg p-3 space-y-1"
        >
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold text-foreground">
              @{getDisplayName(reply)}
            </span>
            <span className="text-xs text-muted-foreground">
              {formatTime(reply.created_at)}
            </span>
          </div>
          <MessageContent
            message={reply.message}
            currentUsername={currentUsername}
            className="text-sm text-foreground"
          />
        </div>
      ))}

      {/* Empty state */}
      {replies.length === 0 && (
        <p className="text-xs text-muted-foreground italic py-2">
          No replies yet
        </p>
      )}
    </div>
  );
};

export default ThreadReplies;
